export default __webpack_public_path__ + "static/media/icon_reader_white.5e349501.svg";